export default __webpack_public_path__ + "static/media/438.4473fcf4.jpg";